// extracted by mini-css-extract-plugin
export default {"sectionWrapper":"Dr-z","outfitFeedbackSection":"Er-z"};